const riskInputDetails = {
  Timestamp: "Timestamp",
  csv_bp:
    "Whats your most recent BP reading? (Should not be more than 3 months old)Example response: 120/80",
  csv_pulse:
    "What's your most heart rate? (Your smart watch reading will suffice)",
  csv_height: "Height (in cms)",
  csv_weight: "Weight (in kgs)",
  csv_treatedForHighBP:
    "Have you been diagnosed with high blood pressure, and are you currently on any treatment or medication for it?",
  csv_isDiabetic: "Are you Diabetic?",
  csv_smoker: "Do you smoke?",
  csv_isUrban: "Are you living in an urban area?",
  csv_familyHistoryOfGraves:
    "Do you have a family history of the grave disease?",
  csv_familyHistoryOfHashimoto:
    "Do you have a family history of hashimoto disease?",
};

const riskTypeMap = {
  heart: "Heart",
  diabetes: "Diabetes",
  thyroid: "Thyroid",
};

export const emailDispatch = async (payload, riskType, clientId) => {
  return;
  if (clientId !== "NGCL0105") {
    return;
  }
  const getSpecificJsonData = () => {
    let data = {};
    switch (riskType) {
      case "diabetes":
        data = {
          [riskInputDetails[
            "csv_bp"
          ]]: `${payload.systolicValue}/${payload.diastolicValue}`,
          [riskInputDetails["csv_pulse"]]: payload.pulseValue,
          BMI: payload.bmiValue,
          [riskInputDetails["csv_isUrban"]]: payload.urbanStatus ? "Yes" : "No",
        };
        break;
      case "heart":
        data = {
          [riskInputDetails["csv_bp"]]: `${payload.sbp}/${
            payload?.diastolicValue || ""
          }`,
          [riskInputDetails["csv_treatedForHighBP"]]: payload.sbpStatus
            ? "Yes"
            : "No",
          [riskInputDetails["csv_smoker"]]: payload.smoking ? "Yes" : "No",
          [riskInputDetails["csv_isDiabetic"]]: payload.diabetes ? "Yes" : "No",
        };
        break;
      case "thyroid":
        data = {
          [riskInputDetails["csv_familyHistoryOfGraves"]]: payload.gravesStatus
            ? "Yes"
            : "No",
          [riskInputDetails["csv_familyHistoryOfHashimoto"]]:
            payload.hashimotoStatus ? "Yes" : "No",
        };
        break;
      default:
        break;
    }
    return data;
  };

  const emailHtmlBody = (jsonObj) => {
    let html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Risk Score</title>
      <style>
       body {
        color: black;
       }
      </style>
    </head>
    <body>
      <p>A patient with Lab Number <b>${
        payload?.labNo || ""
      }</b> has submitted the <b>${
      riskTypeMap[riskType]
    } Risk Score </b> form via the provided link.
Please find the input details below for your reference.</p>
      <ul>
      ${Object.keys(jsonObj)
        .map((key) => ` <li>${key}: <b>${jsonObj[key]}</b></li>`)
        .join("")}
      </ul>
      
    </body>
    </html>
`;
    return html;
  };

  const sendEmail = async () => {
    const url =
      "https://917sfoy1xc.execute-api.ap-south-1.amazonaws.com/Testing/notifications/email";

    const emailData = {
      fromEmail: "reports@niroggyan.com",
      subject: `Risk Score Submission Details - Lab No: ${
        payload?.labNo || ""
      }`,
      toEmail: ["kovid@theoakage.com"],
      cc: ["tech@niroggyan.com"],
      // replyTo: "sales@niroggyan.com",
      bodyType: "html",
      emailBody: emailHtmlBody(getSpecificJsonData()),
      attachments: [],
      withAttachments: false,
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      console.log("emailResponse", data);
    } catch (e) {
      console.log("error in sending email", e);
    }
  };

  await sendEmail();
};
